module.exports = __webpack_public_path__ + "img/USA_LOW_GLYCEMIC.0b213f7e.png";